import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { confirmAlert } from 'react-confirm-alert';

import { NavLink } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";

import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/icons/Menu";

import styles from "assets/jss/material-dashboard-react/components/sidebarStyle.js";
import imageLogo from '../../assets/pontojob_logo_branco.png';

const useStyles = makeStyles(styles);

export default function Sidebar(props) {
  const { color, routes } = props;
  let history = useHistory();
  const classes = useStyles();

  // verifies if routeName is the one active (in browser input)
  function activeRoute(routeName) {
    return window.location.href.indexOf(routeName) > -1 ? true : false;
  }

  const getTitle = () => {
    return (
      <div>
        <i className="icon-logout-2" style={{ fontSize: '52px', color: '#FFFFFF', marginBottom: 60 }} />
        <h5 style={{ marginTop: 30 }}>{'Deseja realmente fazer o logout?'}</h5>
      </div>
    )
  }

  const getMessage = () => {
    return (
      <h3 style={{ marginBottom: 10 }}>{''}</h3>
    )
  }

  const sair = () => {
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      title: getTitle(),
      message: getMessage(),
      buttons: [
        {
          label: 'Sim, Fazer Logout!',
          onClick: async () => {
            localStorage.clear();
            history.push("/");
          }
        },
        {
          label: 'Não',
          onClick: () => { }
        }
      ]
    });
  }

  return (
    <div style={{ backgroundColor: '#364e6b' }}>
      <Hidden>
        <Drawer style={{ position: 'inherit', backgroundColor: '#364e6b', borderRight: '0px' }} variant="persistent" open={true}>
          <IconButton
            style={{ float: 'left', color: '#fff', backgroundColor: '#364e6b', borderRadius: 0, height: 70 }}
            onClick={props.handleDrawerToggle}
          >
            <Menu />
          </IconButton>

          <div className={classes.sidebarWrapper} style={{ backgroundColor: '#364e6b', borderRight: '0px', height: "100%", width: 55 }}>
            <List className={classes.list} style={{ backgroundColor: '#364e6b', borderTop: '1px solid #496484', marginTop: 0 }}>
              {routes.map((prop, key) => {
                var listItemClasses;

                listItemClasses = classNames({
                  [" " + classes[color]]: activeRoute(prop.path)
                });

                if (prop.name === 'Logout') {
                  return (
                    <div
                      className={classes.item}
                      key={key}
                      style={{ margin: 0 }}
                      onClick={() => { sair() }}
                    >
                      <ListItem button className={classes.itemLink + listItemClasses} style={{ display: 'flex', color: '#FFF', paddingTop: 20, paddingBottom: 20, borderBottom: '0px solid #496484', margin: 0, borderRadius: 0 }}>
                        <i className={prop.icon} style={{ width: 20, fontSize: 24, color: '#fff' }}></i>
                      </ListItem>
                      </div>
                  );
                } else {
                  return (
                    <NavLink
                      to={prop.path}
                      className={classes.item}
                      key={key}
                      style={{ margin: 0 }}
                    >
                      <ListItem button className={classes.itemLink + listItemClasses} style={{ display: 'flex', color: '#FFF', paddingTop: 20, paddingBottom: 20, borderBottom: '0px solid #496484', margin: 0, borderRadius: 0 }}>
                        <i className={prop.icon} style={{ width: 20, fontSize: 24, color: '#fff' }}></i>
                      </ListItem>
                    </NavLink>
                  );
                }
              })
              }
            </List>
          </div>
        </Drawer>
      </Hidden>

      <Hidden>
        <Drawer style={{ position: 'inherit', backgroundColor: '#364e6b', borderRight: '0px' }} variant="persistent" open={props ? props.open : false}>
          <div className={classes.logo} style={{ backgroundColor: '#364e6b' }}>
            <div className="text-center" style={{ width: '205px' }}>
              <img src={imageLogo} alt="logo" style={{ width: 140, marginTop: 3 }} />
              <a onClick={() => props.handleDrawerToggle()}>
                <div style={{ float: 'right', position: 'absolute', top: 24, right: 20, cursor: 'pointer' }}>
                  <i className="icon-remove" style={{ color: '#fff', fontSize: 22 }}></i>
                </div>
              </a>
            </div>
          </div>

          <div className={classes.sidebarWrapper} style={{ backgroundColor: '#364e6b', borderRight: '0px' }}>
            <List className={classes.list}>
              {routes.map((prop, key) => {
                var listItemClasses;
                var whiteFontClasses;

                listItemClasses = classNames({
                  [" " + classes[color]]: activeRoute(prop.path)
                });

                whiteFontClasses = classNames({
                  [" " + classes.whiteFont]: activeRoute(prop.path)
                });

                if (prop.name === 'Logout') {
                  return (
                    <div
                      className={classes.item}
                      key={key}
                      onClick={() => { sair() }}
                    >
                      <ListItem button className={classes.itemLink + listItemClasses} style={{ display: 'flex', color: '#FFF' }}>
                        <i className={prop.icon} style={{ width: 38, fontSize: 20, color: '#fff' }}></i>
                        <ListItemText
                          style={{ fontSize: 14 }}
                          primary={prop.name}
                          className={classNames(classes.itemText, whiteFontClasses, {
                            [classes.itemTextRTL]: props.rtlActive
                          })}
                          disableTypography={true}
                        />
                      </ListItem>
                    </div>
                  );
                } else {
                  return (
                    <NavLink
                      to={prop.path}
                      className={classes.item}
                      key={key}
                    >
                      <ListItem button className={classes.itemLink + listItemClasses} style={{ display: 'flex', color: '#FFF' }}>
                        <i className={prop.icon} style={{ width: 38, fontSize: 20, color: '#fff' }}></i>
                        <ListItemText
                          style={{ fontSize: 14 }}
                          primary={prop.name}
                          className={classNames(classes.itemText, whiteFontClasses, {
                            [classes.itemTextRTL]: props.rtlActive
                          })}
                          disableTypography={true}
                        />
                      </ListItem>
                    </NavLink>
                  );
                }
              })
              }
            </List>

            {/* <div style={{
              textAlign: "center",
              padding: "20px",
              position: "fixed",
              left: "0",
              bottom: "0",
              marginBottom: 10,
              height: "60px",
              width: "260px"
            }}>
              <img src={imageLogoTalentRh} alt="Logo" style={{ width: 120, marginBottom: 10 }} />
            </div> */}
          </div>
        </Drawer>
      </Hidden>
    </div>
  );
}

Sidebar.propTypes = {
  rtlActive: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
  bgColor: PropTypes.oneOf(["purple", "blue", "green", "orange", "red"]),
  logo: PropTypes.string,
  image: PropTypes.string,
  logoText: PropTypes.string,
  routes: PropTypes.arrayOf(PropTypes.object),
  open: PropTypes.bool
};
